import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { toaster } from "components/common/Toast"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ACTIONS
const requested = createAction("textGenerator/requested")
const received = createAction("textGenerator/received")
const failed = createAction("textGenerator/failed")
const cleaned = createAction("textGenerator/cleaned")

// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  content: ""
}

const textGenerateReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state)
  },
  [received.type]: (state, action) => {
    setReceived(state)
    state.content = action.payload.paragraph_text
  },
  [failed.type]: (state, msg) => {
    setFailed(state)
    toaster.error({ title: msg.payload.data.message.validation[0] })
  },
  [cleaned.type]: () => initialState
})
export default textGenerateReducer

export const textGenerate = (data) =>
  api({
    url: "/text_generator/generate_text",
    method: "post",
    onStart: requested.type,
    onSuccess: received.type,
    onError: failed.type,
    data: { ...data },
    props: { showToast: false }
  })

export const cleanTextGenerator = () => cleaned()
